const Banner = {
  "--AICartoon-banner-title-color": "#000003",
  "--AICartoon-banner-subtitle-color": "#646B76",

  "--AICartoon-banner-upload-bg": "#FFFFFF",
  "--AICartoon-banner-upload-shadow": "",

  "--AICartoon-banner-upload-btn-color": "#fff",
  "--AICartoon-banner-upload-btn-shadow": "",
  "--AICartoon-banner-upload-btn-bg": "#0270F9",

  "--AICartoon-banner-upload-max-color": "#999999",

  "--AICartoon-banner-upload-tips-color": "#E6E6E6",
}


const Price = {
  "--AICartoon-price-title-color": "#252325",

  "--AICartoon-price-item-shadow": "none",
  "--AICartoon-price-item-shadow-hover": "none",
  "--AICartoon-price-item-border": "",
  "--AICartoon-price-item-border-hover": "",

  // 价格顶部
  "--AICartoon-price-tag-bg": "#E8EEF5",
  "--AICartoon-price-tag-bg-hover": "#0270F9",
  "--AICartoon-price-tag-suffix": "#101112",
  "--AICartoon-price-tag-suffix-hover": "#fff",
  // 详情模块颜色
  "--AICartoon-price-main-bg": "#E8EEF5",
  "--AICartoon-price-main-bg-hover": "#0270F9",
  // 价格颜色
  "--AICartoon-price-money-suffix": "#101012",
  "--AICartoon-price-money-suffix-hover": "#fff",
  // 套餐详情颜色
  "--AICartoon-price-desc-suffix": "#101112",
  "--AICartoon-price-desc-suffix-hover": "#fff",
  // 购买按钮
  "--AICartoon-price-pay-button-suffix": "#fff",
  "--AICartoon-price-pay-button-bg": "#0270F9",
  "--AICartoon-price-pay-button-shadow": "",
  "--AICartoon-price-pay-button-border": "",

  "--AICartoon-price-pay-button-suffix-hover": "#0270F9",
  "--AICartoon-price-pay-button-bg-hover": "#fff",
  "--AICartoon-price-pay-button-shadow-hover": "",
  "--AICartoon-price-pay-button-border-hover": "",

  // 套餐 tips
  "--AICartoon-price-tip-suffix": "#101112",
  "--AICartoon-price-tip-suffix-hover": "#fff",
  "--AICartoon-price-tip-bg": "#E8EEF5",
  "--AICartoon-price-tip-bg-hover": "#0270F9",
}



const Questions = {
  "--AICartoon-questions-title-color": "#252325",

  "--AICartoon-questions-item-bg": "#F2F8FF",
  "--AICartoon-questions-item-bg-open": "#0270F9",

  "--AICartoon-questions-item-boxshadow": "",
  "--AICartoon-questions-item-boxshadow-open": "",

  "--AICartoon-questions-item-border": "3px solid #0270F9",
  "--AICartoon-questions-item-border-open": "2px solid #000000",

  "--AICartoon-questions-item-number-suffix": "#0270F9",
  "--AICartoon-questions-item-number-suffix-open": "#000000",

  "--AICartoon-questions-item-suffix": "#101012",
  "--AICartoon-questions-item-suffix-open": "#fff",
  "--AICartoon-questions-item-des-suffix": '#fff',
}

const Comment = {
  "--AICartoon-comment-title-color": "#fff",

  "--AICartoon-comment-bg": "#0270F9",

  "--AICartoon-comment-item-bg": "rgba(255,255,255,0.2)",
  "--AICartoon-comment-item-bg-hover": "#fff",

  "--AICartoon-comment-item-border": "none",
  "--AICartoon-comment-item-border-hover": "none",

  "--AICartoon-comment-item-boxshadow": "none",
  "--AICartoon-comment-item-boxshadow-hover": "none",

  "--AICartoon-comment-item-subtitle-suffix": "#fff",
  "--AICartoon-comment-item-subtitle-suffix-hover": "#252325",

  "--AICartoon-comment-item-name-suffix": "#fff",
  "--AICartoon-comment-item-name-suffix-hover": "#4C484C",

  "--AICartoon-comment-item-city-suffix": "#fff",
  "--AICartoon-comment-item-city-suffix-hover": "#4C484C",
}


const Case = {
  "--AICartoon-case-title-color": "#252325",

  "--AICartoon-case-bg": "#fff",
  "--AICartoon-case-item-bg": "#fff",
  "--AICartoon-case-item-bg-hover": "#0270F9",

  "--AICartoon-case-item-title-color": "#252325",
  "--AICartoon-case-item-title-color-hover": "#fff",
  "--AICartoon-case-item-desc-color": "#4C484C",
  "--AICartoon-case-item-desc-color-hover": "#fff",

  "--AICartoon-case-item-shadow": "",
  "--AICartoon-case-item-shadow-hover": "",
  "--AICartoon-case-item-border": "3px dashed #0270F9",
  "--AICartoon-case-item-border-hover": "3px solid #0270F9",
}

const Step = {
  "--AICartoon-step-title-color": "#252525",

  "--AICartoon-step-item-title-color": "#252325",
  "--AICartoon-step-item-title-color-hover": "#FFFFFF",
  "--AICartoon-step-item-subtitle-color": "#4C484C",
  "--AICartoon-step-item-subtitle-color-hover": "#FFFFFF",

  "--AICartoon-step-bg": '#f2f8ff',
  "--AICartoon-step-item-bg": "#fff",
  "--AICartoon-step-item-bg-hover": "#0270F9",
  "--AICartoon-step-item-shadow": "0px 10px 30px 0px rgba(0,0,0,0.12)",
  "--AICartoon-step-item-shadow-hover": "",
  "--AICartoon-step-item-border": "none",
  "--AICartoon-step-item-border-hover": "none",
}


export const coustomAICartoonArtifyCartoonTheme = {
  //主题背景颜色
  "--theme-primary": "#0270F9",
  //默认黑
  "--theme-primary-black": "#252325",
  //默认白
  "--theme-primary-white": "#ffffff",
  // 页脚 logo 字体颜色
  "--theme-primary-footer-logo-suffix": "#0270F9",
  // 页头 登录 字体颜色
  "--theme-primary-login-btn-suffix": "#fff",
  // 不透明度70%
  "--theme-primary-white-70": "#b2b2b2",
  //主题亮色
  "--theme-primary-suffix": "#212121",
  //主题深副色
  "--theme-primary-dark-sub": "#E4430F",
  //主题浅副色
  "--theme-primary-light-sub": "#FF8761",
  //价格 tag
  "--theme-primary-price-tag": "#4C3626",
  "--theme-primary-price-tag-bg": "#FFCF52",
  //tiny 类
  "--theme-primary-tiny": "#666166",
  //footer 背景色
  "--theme-primary-footer-bg": "#000000",
  //输入框聚焦
  "--theme-focus": "#3377ff",
  //输入框错误
  "--theme-focus-err": "#ea3042",

  ...Banner,
  ...Price,
  ...Questions,
  ...Comment,
  ...Case,
  ...Step
}